import React, { useEffect, useState } from 'react'
import Header from '../components/Header'
import { Outlet, useLocation } from 'react-router-dom'
import Footer from '../components/Footer'
import CookieBanner from '../components/CookieBanner'
import { motion } from 'framer-motion';
const PageContainer = () => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);


  const [headerToggle, setHeaderToggle] = useState(false)

  const pageTransition = {
    type: 'spring',
    stiffness: 100,
    damping: 25,
    mass: 0.8,
    duration: 1.5,
    ease: [0.25, 0.1, 0.25, 1],
  };


  const pageVariants = {
    initial: {
      translateY: -30,
      scale: 0.95,
      opacity: 0,
    },
    in: {
      translateY: 0,
      scale: 1,
      opacity: 1,
      transition: {
        duration: 0.8,
        ease: [0.25, 0.1, 0.25, 1],
      },
    },
    out: {
      translateY: 30,
      scale: 1,
      opacity: 0,
      transition: {
        duration: 0.6,
        ease: [0.25, 0.1, 0.25, 1],
      },
    },
  };

  return (
    <div>
      <Header headerToggle={headerToggle} setHeaderToggle={setHeaderToggle} />
      <div className={`${headerToggle ? 'blur' : 'blur-0'} duration-300`}>
        <motion.div
          key={location.pathname}
          initial='initial'
          animate='in'
          exit='out'
          variants={pageVariants}
          transition={pageTransition}

          className='overflow-hidden'>
          <Outlet />
        </motion.div>
        <Footer />
      </div>
      <CookieBanner />

      {/* <div className='h-screen w-[10%] fixed right-0 top-0  z-50 flex items-end'>
        <div className='h-1/2 w-full flex justify-center items-center flex-col space-y-5'>
            <img src='/images/header-social/i.svg'/>
            <img src='/images/header-social/f.svg'/>
            <img src='/images/header-social/x.svg'/>
            <img src='/images/header-social/y.svg'/>
        </div>
      </div> */}



    </div>
  )
}

export default PageContainer